var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.26,
    height: 33.474,
    viewBox: "0 0 24.26 33.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat",
    transform: "translate(-10.984 -3.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11135",
    "data-name": "Path 11135",
    d: "M35.229,15.381c0,10.595-12.114,21.19-12.114,21.19S11,25.976,11,15.381a12.114,12.114,0,0,1,24.229,0Z",
    fill: "#fa4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11136",
    "data-name": "Path 11136",
    d: "M19.625,39.314a50.059,50.059,0,0,0,7.139,8.1S36.917,38.534,38.628,28.9A34.553,34.553,0,0,1,19.625,39.314Z",
    transform: "translate(-3.65 -10.846)",
    fill: "#dc3c46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 9.807,
    cy: 9.807,
    r: 9.807,
    transform: "translate(29.838 3.097) rotate(74)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9455",
    "data-name": "Group 9455",
    transform: "translate(15.038 8.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11137",
    "data-name": "Path 11137",
    d: "M39.23,17.769,33.461,12v2.884H30v1.154h4.615V14.884L37.5,17.769l-2.884,2.884V19.5H30v1.154h3.461v2.884Z",
    transform: "translate(-23.078 -12)",
    fill: "#ad2a37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11138",
    "data-name": "Path 11138",
    d: "M22.615,24.653l-2.884-2.884,2.884-2.884v1.154H27.23V18.884H23.769V16L18,21.769l5.769,5.769V24.653H27.23V23.5H22.615Z",
    transform: "translate(-18 -13.693)",
    fill: "#ad2a37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferred);
export default __webpack_public_path__ + "static/media/transferred.33dea4ab2bb94ce85582f5ac5164e053.svg";
export { ForwardRef as ReactComponent };